import {callAPI} from '@/store/utils';

const FYGR_COMPANY = 'FYGR_COMPANY';

export default {
  namespaced: true,
  state: {
    appHeaderBgColor: null,
    appLogo: null,
    appIcon: null,
    appMenuTextColor: null,
    appMenuTextColorOnHover: null,
    appMenuTextColorSelected: null,
    stylesLoaded: false,
    contentKey: null,
    consentIcon: null,
  },
  mutations: {
    unauthCompany(state) {
      state.appHeaderBgColor = null;
      state.appLogo = null;
      state.appMenuTextColor = null;
      state.appMenuTextColorOnHover = null;
      state.appMenuTextColorSelected = null;
      state.appIcon = null;
      state.consentIcon = null;
    },
    setAppStyles(
      state,
      {
        headerColor,
        logo,
        icon,
        contentKey,
        consentIcon,
        appMenuTextColor,
        appMenuTextColorOnHover,
        appMenuTextColorSelected,
      },
    ) {
      state.appHeaderBgColor = headerColor;
      state.appMenuTextColor = appMenuTextColor;
      state.appMenuTextColorSelected = appMenuTextColorSelected;
      state.appMenuTextColorOnHover = appMenuTextColorOnHover;
      state.appLogo = logo;
      state.appIcon = icon;
      state.stylesLoaded = true;
      state.contentKey = contentKey;
      state.consentIcon = consentIcon;
    },
  },
  actions: {
    async actionGetManagedCompanies() {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      return callAPI('POST', 'getManagedCompanies', {companyId});
    },
    async actionCalculateVat(_, params) {
      return callAPI('POST', 'calculateVat', {...params});
    },
    async actionSetEndOfTrialPeriodForCompany(_, params) {
      return callAPI(
        'POST',
        'setEndOfTrialPeriodForCompany',
        {...params},
        true,
        0,
      );
    },
    async actionUnauthCompany({commit}) {
      commit('unauthCompany');
    },
    async actionGetPuk() {
      const companyId = localStorage.getItem(FYGR_COMPANY);
      return callAPI('POST', 'getPuk', {companyId});
    },
    async actionCheckPuk(_, data) {
      return callAPI('POST', 'checkPuk', data);
    },
    async actionGetStyles({commit}, data) {
      if (data && Object.keys(data).includes('headerColor')) {
        commit('setAppStyles', data);
        return;
      }
      const res = await callAPI('POST', 'getStyles', data, true);
      if (!res.error) {
        commit('setAppStyles', {
          headerColor: res.result.app_header_bg_color,
          logo: res.result.app_logo,
          icon: res.result.app_icon,
          contentKey: res.result.content_key,
          consentIcon: res.result.consent_icon,
        });
      }
    },
    async actionUpdateCompanyModules({commit}, params) {
      const company_id = localStorage.getItem(FYGR_COMPANY);
      return await callAPI('PATCH', `company/${company_id}/modules`, {
        company_id,
        ...params,
      });
    },

    async actionSaveBranding({commit}, params) {
      const company_id = localStorage.getItem(FYGR_COMPANY);
      return await callAPI(
        params.requestType, // POST or PUT
        `company/${company_id}/branding${params.brandingId}`,
        {
          company_id,
          ...params,
        },
      );
    },
    async actionGetBranding({commit}) {
      const company_id = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI('GET', `company/${company_id}/branding`);
      return res;
    },
    async actionDeleteBranding({commit}, brand_id) {
      const company_id = localStorage.getItem(FYGR_COMPANY);
      const res = await callAPI(
        'DELETE',
        `company/${company_id}/branding/${brand_id}`,
      );
      return res;
    },
  },
};
